export const getStorage =(storageName) =>  {  //获取历史记录，storageName为保存历史记录名称，有数据时返回值是一个对象，无数据返回空
    var historyListJson = localStorage.getItem(storageName) || null;
    if (historyListJson) {
        var historyData = JSON.parse(historyListJson);
        var endTime = historyData.endTime ? historyData.endTime : 0;
        var nowTime = new Date().getTime();
        if (endTime > 0) {
            if (endTime < nowTime) {  //保存时间和现在对比，小于时主题已过期
                localStorage.removeItem(storageName);
                return '';
            } else {
                return historyData.data;
            }
        } else { //0时为没有设置时间，表示长期有交
            return historyData.data;
        }
    } else {
        return '';
    }
}
export const setStorage =(storageName, value, time) => {  //storageName保存记录的名称，value为保存值   time为分钟
    var obj = {};
    if (time) {
        var d = new Date();
        var st = 1000 * 60 * parseInt(time);
        obj.endTime = d.getTime() + st;//获取结束毫秒值
    } else { //endTime为0时，表示长期保存  上面getStorage方法有做处理
        obj.endTime = 0;
    }
    obj.data = value;
    localStorage.setItem(storageName, JSON.stringify(obj));
};
export const clearStorage =(storageName) =>{  //storageName有名称删除指定名字，没有设置，清空所有
    if (storageName) {
        localStorage.removeItem(storageName);
    } else {
        localStorage.clear();
    }
};


// WEBPACK FOOTER //
// ./src/utils/common.js